import React, { useRef, useEffect, useState } from 'react';
import { motion, useInView } from 'framer-motion';
import './GenixPendant.css';
import { useNavigate } from "react-router-dom";

const GenixPendant = ({ isFixed }) => {
  const containerRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const isInView = useInView(containerRef, { 
    once: true,
    margin: "-20% 0px -20% 0px",
    amount: 0.4
  });
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const scrollPercentage = Math.max(0, Math.min(1, 1 - (rect.bottom / (windowHeight + rect.height))));
        setScrollProgress(scrollPercentage);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section 
      className={`pendant-section ${isFixed ? 'fixed' : ''}`} 
      ref={containerRef}
      style={{ '--scroll-progress': scrollProgress }}
    >
      <div className="pendant-container">
        <motion.div 
          className="pendant-content"
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h2>Genix Pendant</h2>
          <p>
            Genix Pendant is a next-generation wearable device designed to act as an AI-powered 
            healthcare assistant. It transforms clinical conversations into{' '}
            <span className="highlight">real-time, multilingual, structured, and actionable data</span>,
            right from the moment it hears your voice.
          </p>
          <motion.button 
            className="try-button"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate("/try-genix-pendant")}
          >
            Try Genix Pendant
            <svg className="arrow" viewBox="0 0 24 24">
              <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
            </svg>
          </motion.button>
        </motion.div>
        <motion.div 
          className="pendant-image"
          initial={{ opacity: 0, x: 100 }}
          animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 100 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          style={{
            transform: `translateY(${scrollProgress * -50}px)`
          }}
        >
          <img 
            src="/images/pendent.png" 
            alt="Genix Pendant being worn" 
            className="pendant-photo"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default GenixPendant; 